const MOBILE_PREFIX = "/m";

const MOBILE_ROUTE_PATHS = [
  "/personalCenter",
  "/listManagement",
  "/incomeCenter",
];

const splitPath = (path: string) => {
  const match = path.match(/^([^?#]*)(.*)$/);
  return {
    pathname: match?.[1] || "/",
    suffix: match?.[2] || "",
  };
};

const isMobileRoutePath = (pathname: string) => (
  MOBILE_ROUTE_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
);

export const getDeviceRedirectPath = (path: string, isMobileDevice: boolean) => {
  const { pathname, suffix } = splitPath(path);
  const isMobilePath = pathname === MOBILE_PREFIX || pathname.startsWith(`${MOBILE_PREFIX}/`);

  if (isMobileDevice) {
    if (isMobilePath || !isMobileRoutePath(pathname)) {
      return null;
    }

    return `${MOBILE_PREFIX}${pathname}${suffix}`;
  }

  if (!isMobilePath) {
    return null;
  }

  const pcPath = pathname.replace(MOBILE_PREFIX, "") || "/";

  return `${pcPath}${suffix}`;
};
